import React from 'react';
import { reduxForm, Field } from 'redux-form';
import i18next from 'i18next';

import { SelectInput } from '../SelectInput';

class UserUpdateTempUnitForm extends React.Component {

  constructor(props) {
    super(props);

    this.props.initialize({temperatureDisplayUnit: this.props.selectedUnit});
  }

  render() {
    const { handleSubmit, units } = this.props;

    return (
        <div>
          <form onSubmit={handleSubmit}>
            <div className="op-content-box op-card form-group">
              <div>
                <p className="panel-heading">Temperature Display Unit:</p>
              </div>
              <div className="add-margin-bottom">
                  <Field
                    name="temperatureDisplayUnit"
                    options={units}
                    isSearchable={true}
                    clearable={false}
                    component={SelectInput}
                  />
              </div>
              <div className="pull-right">
                <button type="submit" className="btn btn-primary">{i18next.t('form-labels.save')}</button>
              </div>
            </div>
          </form>
        </div>
    );
  }

}

export default reduxForm({ form: "UserUpdateTempUnitForm" })(UserUpdateTempUnitForm);
